import React, {useLayoutEffect} from "react";
import {Tooltip} from "antd";
import {ThunderboltFilled, InsertRowAboveOutlined, ScheduleOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {TableContainer, ActionButtons, StatDetail} from "./ResponsiveDataTable.styles";
import {useHistory} from "react-router-dom";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";
import {useStore} from "../../../../hooks/useStore";
import {EmptyMessage} from "../../../_defaultComponents/EmptyMessage/EmptyMessage";

const TABLE_PREFIX = "poolTable";
const ResponsiveDataTable = ({
    data = [],
    dynamicColumns = [],
    loading,
    currentPage,
    setCurrentPage,
    dataCount
}) => {
    const {t} = useTranslation(["pools"]);
    const history = useHistory();

    const onClickDetailButton = poolId => {
        history.push(`/pools/${poolId}/daily-slots`);
    };
    const renderActionButtons = id => {
        const permisions = {
            showForecastTable: true,
            showSlotTable: true,
            showShifts: true
        };
        return (
            <ActionButtons>
                {permisions.showForecastTable && (
                    <Tooltip title={"Forecast"}>
                        <CustomButton
                            data-testid="poolShiftStatDetailButton"
                            onClick={() => history.push(`/pools/${id}/daily-forecasts`)}
                            icon={<ThunderboltFilled />}
                        ></CustomButton>
                    </Tooltip>
                )}
                {permisions.showSlotTable && (
                    <Tooltip title={"Slot"}>
                        <CustomButton
                            data-testid="poolShiftStatDetailButton"
                            onClick={() => history.push(`/pools/${id}/daily-slots`)}
                            icon={<InsertRowAboveOutlined />}
                        ></CustomButton>
                    </Tooltip>
                )}
                {permisions.showShifts && (
                    <Tooltip title={"Vardiyalar"}>
                        <CustomButton
                            data-testid="poolShiftStatDetailButton"
                            onClick={() => history.push(`/pools/courier-shifts?poolId=${id}`)}
                            icon={<ScheduleOutlined />}
                        ></CustomButton>
                    </Tooltip>
                )}
            </ActionButtons>
        );
    };

    const onClickStatButton = ({date, poolId}) => {
        history.push(`/pools/courier-shifts?poolId=${poolId}&date=${date}`);
    };
    return (
        <>
            <TableContainer
                className={TABLE_PREFIX}
                pagination={{
                    total: dataCount,
                    current: currentPage,
                    onChange: async page => {
                        setCurrentPage(page);
                        history.push("/pools/shift-management?page=" + page);
                    },
                    hideOnSinglePage: true,
                    showSizeChanger: false,
                    defaultPageSize: 5
                }}
                rowKey="_id"
                rowClassName="hello"
                dataSource={data}
                locale={{
                    emptyText: <EmptyMessage />
                }}
                data-testid="poolDataTable"
                loading={loading}
            >
                <TableContainer.Column
                    dataIndex="name"
                    title={t("fields.poolRegion", {ns: "pools"})}
                    render={name => (
                        <span
                            data-testid="poolName"
                            data-label={`${t("fields.poolRegion", {ns: "pools"})}:`}
                        >
                            {name}
                        </span>
                    )}
                />
                {dynamicColumns.map((date, index) => (
                    <TableContainer.Column
                        dataIndex={[`slots`, date]}
                        rowKey={index}
                        key={JSON.stringify(date) + index}
                        title={date}
                        render={(data, stats) => (
                            <StatDetail
                                key={JSON.stringify(data) + index}
                                data-testid="poolCompaniesCount"
                                data-label={`${date}:`}
                                onClick={() => onClickStatButton({date, poolId: stats?._id})}
                            >
                                <span>
                                    <span style={{marginRight: "2px"}}>Limit :</span>
                                    <b>{data?.totalPickable || 0}</b>
                                </span>
                                <br />
                                <span>
                                    <span style={{marginRight: "2px"}}>Yerleşen :</span>{" "}
                                    <b>{data?.totalPick || 0}</b>
                                </span>
                                <br />
                                <span>
                                    <span style={{marginRight: "2px"}}>Doluluk Oranı :</span>
                                    <b>
                                        {data?.totalPickable
                                            ? `${Math.round(
                                                  (data?.totalPick / data?.totalPickable) * 100
                                              )}%`
                                            : "0%"}
                                    </b>
                                </span>
                                <br />
                                <span>
                                    <span style={{marginRight: "2px"}}>Forecast :</span>
                                    <b>{data?.forecastCreated ? "Evet" : "Hayır"}</b>
                                </span>
                            </StatDetail>
                        )}
                    />
                ))}

                <TableContainer.Column
                    align="right"
                    title={t("actions.action", {ns: "common"})}
                    dataIndex="_id"
                    render={renderActionButtons}
                />
            </TableContainer>
        </>
    );
};

export default ResponsiveDataTable;
